<template>
  <div class="bidding">
    <div class="left">
      <div class="title">公告栏</div>
      <div class="tab">
        <ul>
          <li :class="{active: tab == 0}" @click="changeTab(0, '50af3433-9e9d-4921-aa8d-b994f62a9fa0')">招标</li>
          <li :class="{active: tab == 1}" @click="changeTab(1, 'b17cc9c5-81e9-4218-9814-656b92adcd33')">中标</li>
          <li :class="{active: tab == 2}" @click="changeTab(2, '0257b4f0-caac-481e-b528-5b096710301b')">更正</li>
          <li :class="{active: tab == 3}" @click="changeTab(3, 'adfbde77-a1ca-4a4f-85c9-50de200824de')">废标</li>
          <li :class="{active: tab == 4}" @click="changeTab(4, 'f0702311-738d-4642-91ba-af6d1cf6a2c9')">单一来源</li>
        </ul>
      </div>
      <div class="news">
        <ul>
          <li :title="news.newsContentTitle" v-for="(news, idx) in biddingList" :key="idx" @click="goDetail(news.newsContentLink, news.templateRecordUrl, news.newsContentType, news.newsContentContent)">
            <span>{{news.newsContentTitle}}</span>
            <em>{{news.newsContentPublishTime}}</em>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <div class="title">
        <span>系统登录</span>
        <em></em>
      </div>
      <div class="btn">
        <div class="btn-box">
          <a href="http://39.102.204.93/news/" target="_blank">
            <img src="@/assets/images/btn-box1.png" alt="">
            员工登录
          </a>
        </div>
        <div class="btn-box">
          <a href="javascript:void(0);">
            <img src="@/assets/images/btn-box2.png" alt="">
            专家库
          </a>
        </div>
        <div class="btn-box">
          <a href="javascript:void(0);">
            <img src="@/assets/images/btn-box3.png" alt="">
            服务咨询
          </a>
        </div>
        <div class="btn-box">
          <a href="javascript:void(0);">
            <img src="@/assets/images/btn-box4.png" alt="">
            供应商报名
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/assets/public/url'
import axios from "axios";
export default {
  name: "Bidding",
  components: {},
  data() {
    return {
      url: url.url,
      page: {
        page: 1,
        rows: 7,
        newsDirectoriesId: '50af3433-9e9d-4921-aa8d-b994f62a9fa0'
      },
      biddingList: [],
      tab: 0
    }
  },
  methods: {
    goDetail: function (link, url, type, outlink) {
      if (type === '6') {
        window.open(outlink)
      } else {
        window.open(this.url + '/' +url)
      }
    },
    changeTab: function (tab, id) {
      this.tab = tab
      this.page.newsDirectoriesId = id
      this.getList()
    },
    getList: function () {
      var self = this
      axios.get(self.url + '/news/app/newscontent/listpagenewscontentrelease', {
        params: self.page
      }).then(function (res) {
        self.biddingList = res.data.rows
        console.log(self.biddingList)
      })
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.bidding
  width 1200px
  margin 20px auto 40px
  &:after
    content ''
    display block
    clear both
  .left
    width 880px
    float left
    box-shadow 0 0 10px #eee
    padding 15px 20px
    box-sizing border-box
    .title
      color $main-red
      border-bottom 1px solid #ddd
      font-size 20px
      padding-bottom 15px
    .tab
      margin-top 10px
      ul
        overflow hidden
        li
          float left
          margin-right 10px
          font-size 16px
          color #333
          cursor pointer
          padding 0 5px
          &.active
            color #fff
            background $main-red
    .news
      margin-top 20px
      ul
        height 282px
        li
          height 40px
          line-height 40px
          font-size 14px
          cursor pointer
          &:hover
            color $main-red
          span
            display inline-block
            max-width 80%
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
          em
            float right
            color #ccc
  .right
    float right
    width 300px
    padding 15px 20px
    box-sizing border-box
    box-shadow 0 0 10px #eee
    .title
      height 42px
      font-size 20px
      color $main-red
      overflow hidden
      span
        float left
      em
        display inline-block
        float right
        width 65%
        height 15px
        background #e9e9e9
        margin-top 6px
    .btn
      .btn-box
        margin-bottom 15px
        background #f4f4f4
        padding 10px
        &:last-child
          margin-bottom 0
        a
          display block
          background #fff
          border 1px solid #DDD
          padding  10px 0 10px 20px
          line-height 30px
          img
            margin-right 10px
</style>



// WEBPACK FOOTER //
// src/pages/Index/components/Bidding.vue